var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBecomeAgentIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0007,
    cy: 17.5007,
    r: 11.6667,
    fill: "#DC143C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1243 64.1667C43.3121 64.1667 40.906 64.1667 39.411 62.6717C37.916 61.1767 37.916 58.7706 37.916 53.9583C37.916 49.1461 37.916 46.74 39.411 45.245C40.906 43.75 43.3121 43.75 48.1243 43.75C52.9366 43.75 55.3427 43.75 56.8377 45.245C58.3327 46.74 58.3327 49.1461 58.3327 53.9583C58.3327 58.7706 58.3327 61.1767 56.8377 62.6717C55.3427 64.1667 52.9366 64.1667 48.1243 64.1667ZM53.8645 51.7586C54.5289 51.0942 54.5289 50.0169 53.8645 49.3525C53.2 48.6881 52.1228 48.6881 51.4583 49.3525L45.8558 54.955L44.7904 53.8895C44.1259 53.2251 43.0487 53.2251 42.3842 53.8895C41.7198 54.554 41.7198 55.6312 42.3842 56.2957L44.6528 58.5642C45.3172 59.2286 46.3945 59.2286 47.0589 58.5642L53.8645 51.7586Z",
    fill: "#DC143C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9603 39.3959C42.0141 38.4534 38.6172 37.916 35.0007 37.916C23.7248 37.916 14.584 43.1394 14.584 49.5827C14.584 55.826 23.1661 60.9239 33.9569 61.2344C33.8777 60.866 33.8165 60.5004 33.7683 60.1413C33.5417 58.4562 33.542 56.3975 33.5423 54.2084V53.7069C33.542 51.5178 33.5417 49.4591 33.7683 47.774C34.0203 45.899 34.6229 43.8465 36.3188 42.1507C38.0146 40.4548 40.067 39.8523 41.9421 39.6002C42.852 39.4779 43.8708 39.4217 44.9603 39.3959Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeAgentIcon1);
export default __webpack_public_path__ + "static/media/become-agent-icon-1.8d3648f8451cdf4d351ec5eaceb5ca60.svg";
export { ForwardRef as ReactComponent };